import Reveal from "./Reveal";
import { ShieldCheck, Zap, Leaf, Users, Scale } from "lucide-react";

const coreValues = [
  {
    icon: ShieldCheck,
    title: "Quality",
    desc: "Providing reliable, high-performance concrete consistently for every project, every time.",
  },
  {
    icon: Zap,
    title: "Innovation",
    desc: "Utilizing AI, IoT, and other cutting-edge technologies to optimize every batch.",
  },
  {
    icon: Leaf,
    title: "Sustainability",
    desc: "Minimizing environmental impact through grey water recycling and eco-friendly practices.",
  },
  {
    icon: Users,
    title: "Customer Focus",
    desc: "Fostering long-term relationships with tailored solutions and dependable service.",
  },
  {
    icon: Scale,
    title: "Integrity",
    desc: "Committing to the highest levels of professionalism and ethics in all operations.",
  },
];

const CoreValues = () => (
  <section
    className="w-full py-12 md:py-16 lg:py-20 px-4 md:px-10 lg:px-16"
    style={{ background: "#041122" }}
  >
    <div className="max-w-7xl mx-auto">
      <Reveal className="text-center mb-12">
        <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
          [ OUR CORE VALUES ]
        </span>

        <h2 className="text-2xl md:text-3xl lg:text-4xl text-white xl:text-5xl tracking-wider  font-semibold font-heading leading-relaxed mt-3 ">
          What Drives Us Every Day
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {coreValues.map((v, i) => {
          const Icon = v.icon;

          return (
            <Reveal key={v.title} delay={i * 80}>
              <div
                className="rounded-2xl p-5 h-full group cursor-default"
                style={{
                  background: "#ffffff0a",
                  border: "1px solid #ffffff0f",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#B3129E18";
                  e.currentTarget.style.borderColor = "#B3129E55";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#ffffff0a";
                  e.currentTarget.style.borderColor = "#ffffff0f";
                }}
              >
                {/* icon */}
                <div className="mb-3">
                  <Icon size={26} strokeWidth={2} className="text-[#B3129E]" />
                </div>

                <h3 className="font-bold text-white text-sm mb-2">{v.title}</h3>

                <p className="text-gray-400 text-xs leading-relaxed">
                  {v.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default CoreValues;
